import { setFrame } from './private/set_frame.js';

export const openFrame = async (original_frame, assign) => setFrame(original_frame, assign, $.frame.open);
